import { useNavigate } from "react-router-dom";
import { Shield, FileText, AlertTriangle } from "lucide-react";

const FooterLegal = () => {
  const navigate = useNavigate();

  const navigateToPage = (path: string) => {
    navigate(path);
    // Scroll to top after navigation
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  return (
    <div>
      <h3 className="text-xl font-semibold mb-6 text-red-400">Legal</h3>
      <ul className="space-y-4 flex flex-col items-center sm:items-start">
        <li>
          <button 
            onClick={() => navigateToPage('/privacy')} 
            className="flex items-center text-gray-300 hover:text-white transition-colors group"
          >
            <Shield className="h-5 w-5 mr-3 text-red-500" />
            <span className="text-lg group-hover:translate-x-1 transform duration-200">Privacy Policy</span>
          </button>
        </li>
        <li>
          <button 
            onClick={() => navigateToPage('/terms')} 
            className="flex items-center text-gray-300 hover:text-white transition-colors group"
          >
            <FileText className="h-5 w-5 mr-3 text-red-500" />
            <span className="text-lg group-hover:translate-x-1 transform duration-200">Terms of Service</span>
          </button>
        </li>
        <li>
          <button 
            onClick={() => navigateToPage('/disclaimer')} 
            className="flex items-center text-gray-300 hover:text-white transition-colors group"
          >
            <AlertTriangle className="h-5 w-5 mr-3 text-red-500" />
            <span className="text-lg group-hover:translate-x-1 transform duration-200">Disclaimer</span>
          </button>
        </li>
        <li>
          <button 
            onClick={() => navigateToPage('/dmca')} 
            className="flex items-center text-gray-300 hover:text-white transition-colors group"
          >
            <AlertTriangle className="h-5 w-5 mr-3 text-red-500" />
            <span className="text-lg group-hover:translate-x-1 transform duration-200">DMCA</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default FooterLegal;
